/**
 * Disables the button/input[submit] and replaces content with a spinner based on the provided model.
 * @example <button type="submit" v-submit="submitting">Submit!</button>
 *          'Submit!' will be replaced with a spinner if `loading` and otherwise if `!loading`
 */
Vue.directive('submit', {
    bind(el) {
        el.initialHTML = el.innerHTML
    },

    update(el, binding) {
        if (binding.value) {
            el.innerHTML = "<i class='fa fa-spinner fa-spin'></i>"
            el.disabled = true
        } else {
            el.innerHTML = el.initialHTML
            el.disabled = false
        }
    }
})

Vue.directive('numbers-only', {
    inserted(el) {
        $(el).keypress(e => {
            if (isNaN(String.fromCharCode(e.which))) {
                e.preventDefault()
            }

            // enter is not allowed
            if (e.keyCode == 13) {
                e.preventDefault()
            }
        })
    }
})

Vue.directive('select-no-keyboard', {
    inserted(el) {
        let element = el.tagName === 'SELECT' ? el : $(el).find('select')[0]
        $(element).on('keydown', e => {
            if (!e) {
                e = window.event;
            }
            e.returnValue = false
            e.cancel = true
            e.preventDefault()
        })
    }
})